export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Ldap.json?hash=c248db7a99cd9b58b089c15bfa8ecb3b";